import React from "react";
import InfoIcon from "./../../assets/Info.svg";

const CompletedPage = ({ goBack,page }) => {
  return (
    <div className="completed_page_container">
      <div className="completed_page_details">
        <img
          src={InfoIcon}
          alt="Info"
          style={{
            width: "120px",
          }}
        />
        {page===1?<> <div className="completed_page_content">
          
          Please contact MRC@myseiubenefits.org for enrollment support.
        </div>
       </>:<> <div className="completed_page_content">
          You have already enrolled/completed this Learning Plan.<br/>
          Please contact MRC@myseiubenefits.org for enrollment support.
        </div>
        <button className="button" style={{ width: "100px" }} onClick={goBack}>
          Back
        </button></>}
       
      </div>
    </div>
  );
};

export default CompletedPage;
